import useRoutesHandler from "@/Hooks/useRouteHandler";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { memo } from "react";
import { Link } from "react-router-dom";

const BreadCrumb = memo(() => {
  const partner = import.meta.env.VITE_USER === "partner";
  BreadCrumb.displayName = "BreadCrumb";
  const { subRoute } = useRoutesHandler();
  if (partner) return <></>;
  return (
    <div className="flex items-center gap-2 text-sm  ">
      <Link
        to="/home"
        className={`text-sm font-medium  
          "text-body hover:text-primary"
        `}
      >
        Home
      </Link>
      <ChevronRightIcon className="text-gray size-4" />
      <span className="text-sm font-black text-heading  capitalize">
        {stringUtility.removeCharAddSpace(subRoute, "-")}
      </span>
    </div>
  );
});

export default BreadCrumb;
